import {
    AuditOutlined,
    BankOutlined,
    CalculatorFilled,
    CopyFilled,
    DashboardFilled,
    FileDoneOutlined,
    PoweroffOutlined,
    PercentageOutlined,
    SettingOutlined,
    ToolFilled,
    UserOutlined,
    UsergroupAddOutlined,
    ApartmentOutlined,
    DatabaseOutlined,
    InfoCircleOutlined,
    FileOutlined,
    CalculatorOutlined,
    ReconciliationOutlined,
    CreditCardOutlined,
    WalletOutlined,
    FormOutlined,
    BookOutlined,
    ScissorOutlined,
    MedicineBoxOutlined,
    PauseCircleOutlined,
    // Documents
    ExperimentOutlined,
    SafetyCertificateOutlined,
    EyeOutlined,
    PlusSquareOutlined,
    // Extra - Documents
    SendOutlined,
    TagOutlined,
    IdcardOutlined,
    // Comptabilité
    ContainerOutlined,
    PartitionOutlined,
    SearchOutlined,
    FundOutlined,
    // Extra - Compta
    AccountBookOutlined,
    BuildOutlined,
    LineChartOutlined,
    ExportOutlined,
    // Paie et RH
    DollarCircleOutlined,
} from '@ant-design/icons';

/**
 * Configuration centralisée du menu
 * Cette structure est utilisée par SideMenu et LayoutComp pour garantir la synchronisation
 */
export const menuConfig = [
    {
        label: 'Tableau de Bord',
        key: 'dashboard',
        path: '/dashboard',
        icon: <DashboardFilled />
    },
    {
        label: 'Fichiers',
        key: 'structure',
        icon: <ApartmentOutlined />,
        children: [
            { label: 'Données de Base', key: '/donnees_bases', path: '/donnees_bases', icon: <FileDoneOutlined /> },
            { label: 'Adhérents', key: '/adherents', path: '/adherents', icon: <BankOutlined /> },
            { label: 'Fournisseurs de Soins', key: '/fournisseurs', path: '/fournisseurs', icon: <AuditOutlined /> },
            { label: 'Participants', key: '/participants', path: '/participants', icon: <UsergroupAddOutlined /> }
        ]
    },
    {
        label: 'Paramètres',
        key: 'params',
        icon: <SettingOutlined />,
        children: [
            { label: 'Taux de Prise en Charge', key: '/tauxpc', path: '/tauxpc', icon: <PercentageOutlined /> },
            { label: 'Utilisateurs', key: '/users', path: '/users', icon: <UserOutlined /> },
            { label: 'Informations Générales', key: '/informations', path: '/informations', icon: <InfoCircleOutlined /> },
        ]
    },
    {
        label: 'Documents',
        key: 'docs',
        icon: <CopyFilled />,
        children: [
            { label: 'Bons de Pharmacies', key: '/bons_pharmacies', path: '/bons_pharmacies', icon: <ExperimentOutlined /> },
            { label: 'Lettres de Garantie', key: '/lettres_garanties', path: '/lettres_garanties', icon: <SafetyCertificateOutlined /> },
            { label: 'Bons Optiques', key: '/bons_optiques', path: '/bons_optiques', icon: <EyeOutlined /> },
            { label: 'Lettres Hospitalisation', key: '/lg_hospitalisation', path: '/lg_hospitalisation', icon: <PlusSquareOutlined /> },
        ]
    },
    {
        label: 'Extra - Documents',
        key: 'extradocs',
        icon: <CopyFilled />,
        children: [
            { label: 'Ordres de Paiement', key: '/ordre_paiement', path: '/ordre_paiement', icon: <SendOutlined /> },
            { label: "Bons d'Achat", key: '/bon_achat', path: '/bon_achat', icon: <TagOutlined /> },
            { label: 'Factures Adhérents', key: '/Facture_Adherent', path: '/Facture_Adherent', icon: <IdcardOutlined /> }
        ]
    },
    {
        label: 'Traitements - Saisies',
        key: 'process',
        icon: <ToolFilled />,
        children: [
            { label: 'Factures Fournisseurs', key: '/factures', path: '/factures', icon: <ReconciliationOutlined /> },
            { label: 'Réglement Factures', key: '/reglements', path: '/reglements', icon: <CreditCardOutlined /> },
            { label: 'Saisie Encaissement', key: '/saisie_encaissement', path: '/saisie_encaissement', icon: <WalletOutlined /> },
            { label: 'Saisie Cotisations', key: '/cotisations', path: '/cotisations', icon: <FormOutlined /> },
            { label: 'Saisie Journal', key: '/saisie_journal', path: '/saisie_journal', icon: <BookOutlined /> },
            { label: 'Retenues Frais Médicaux', key: '/retenues', path: '/retenues', icon: <ScissorOutlined /> },
            { label: 'Remb. Frais Médicaux', key: '/remboursements', path: '/remboursements', icon: <MedicineBoxOutlined /> },
            { label: 'Suspensions', key: '/suspensions', path: '/suspensions', icon: <PauseCircleOutlined /> },
        ]
    },
    {
        label: 'Comptabilité',
        key: 'compta',
        icon: <CalculatorFilled />,
        children: [
            { label: 'Journal Central', key: '/journal-central', path: '/journal-central', icon: <ContainerOutlined /> },
            { label: 'Plan Comptable', key: '/plancompta', path: '/plancompta', icon: <PartitionOutlined /> },
            { label: 'Interrogations Comptes', key: '/interrogation_compte', path: '/interrogation_compte', icon: <SearchOutlined /> },
            { label: 'Etat Compta & Fin', key: '/etat_comptafin', path: '/etat_comptafin', icon: <FundOutlined /> }
        ]
    },
    {
        label: 'Extra - Compta',
        key: 'extra',
        icon: <CalculatorOutlined />,
        children: [
            { label: 'Rapp. Bancaires', key: '/rapport_banque', path: '/rapport_banque', icon: <AccountBookOutlined /> },
            { label: 'Immobilisations', key: '/immobilisation', path: '/immobilisation', icon: <BuildOutlined /> },
            { label: 'Prévision Budget', key: '/budget', path: '/budget', icon: <LineChartOutlined /> },
            { label: 'Reporting & Export', key: '/reporting', path: '/reporting', icon: <ExportOutlined /> }
        ]
    },
    {
        label: 'Paie et RH',
        key: 'paie',
        icon: <DatabaseOutlined />,
        children: [
            { label: 'Gestion Paie', key: '/gestion-paie', path: '/gestion-paie', icon: <DollarCircleOutlined /> },
        ]
    },
    {
        label: 'Textes et Réglements',
        key: 'text&reglement',
        path: '/text&reglement',
        icon: <FileOutlined />
    },
    {
        type: 'divider',
        style: { borderColor: 'rgba(255,255,255,0.2)', margin: '8px 0' }
    },
    {
        label: 'Déconnexion',
        icon: <PoweroffOutlined />,
        key: 'signout',
        danger: true,
        style: { marginTop: 'auto', fontWeight: 'bold' }
    }
];

/**
 * Utilitaire pour chercher un item dans la configuration par path
 */
export const findMenuItemByPath = (pathname, config = menuConfig) => {
    for (const item of config) {
        // Cas direct : l'item n'a pas d'enfants
        if (item.path === pathname) {
            return { parent: null, child: item };
        }

        // Cas avec enfants
        if (item.children && Array.isArray(item.children)) {
            for (const child of item.children) {
                if (child.path === pathname) {
                    return { parent: item, child };
                }
            }
        }
    }
    return { parent: null, child: null };
};

/**
 * Utilitaire pour chercher un item dans la configuration par clé
 */
export const findMenuItemByKey = (key, config = menuConfig) => {
    for (const item of config) {
        if (item.key === key) {
            return { parent: null, child: item };
        }

        if (item.children && Array.isArray(item.children)) {
            for (const child of item.children) {
                if (child.key === key) {
                    return { parent: item, child };
                }
            }
        }
    }
    return { parent: null, child: null };
};

/**
 * Utilitaire pour obtenir tous les chemins disponibles de la configuration
 */
export const getAllMenuPaths = (config = menuConfig) => {
    const paths = [];
    for (const item of config) {
        if (item.path) {
            paths.push(item.path);
        }
        if (item.children && Array.isArray(item.children)) {
            for (const child of item.children) {
                if (child.path) {
                    paths.push(child.path);
                }
            }
        }
    }
    return paths;
};
